var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import moment from 'moment-timezone';
import { default as React, useState } from 'react';
import { Button, ButtonVariant } from '../Components/Button';
import { StyledDialog } from '../Components/Dialog/StyledDialog';
import { StyledDialogButton } from '../Components/Dialog/StyledDialogButton';
import { CloseIcon } from '../Components/Icons';
import { displayError, displayMessage } from '../Config/ApplicationConfig';
import { expiryDate, getDurationType, performedDate } from '../MedicationSummary/MedicationSummaryDuration';
import { emptyGuid } from '../Shared/Constants';
import { ValidDateFormats } from '../Shared/DateUtilities';
import { white50 } from '../Styles/Colours';
import { ControlledDialogActions } from './ControlledMedicationDialog';
import { getExpiresOn } from './ReprescribeMedication';
import styles from './ReprescribeSingleMedicationDialog.module.css';
import { LayoutCentral } from '../Components/LayoutCentral';
import { ColorLinearProgress } from '../Components/ColorLinearProgress';
import { MedicationStatus } from '../Contracts/MedicationModels';
export var ReprescribeSingleMedicationDialog = function (props) {
    var _a = __read(useState(false), 2), represcribing = _a[0], setReprescribing = _a[1];
    var represcribeMedication = function () { return __awaiter(void 0, void 0, void 0, function () {
        var expiresOnMoment, performedOnMoment, durationType, represcribeValues, shortedMedsDetails, represcribedMedications, e_1;
        var _a, _b, _c, _d;
        return __generator(this, function (_e) {
            switch (_e.label) {
                case 0:
                    expiresOnMoment = expiryDate(props.lastMedication.medication.expiresOn);
                    performedOnMoment = performedDate(props.lastMedication.medication.performedOn, ValidDateFormats.IsoFormat);
                    durationType = getDurationType(expiresOnMoment, performedOnMoment);
                    represcribeValues = {
                        medications: [
                            {
                                medication: __assign(__assign({}, props.lastMedication.medication), { name: props.medicationName }),
                                poisonSchedule: (_b = (_a = props.lastMedication) === null || _a === void 0 ? void 0 : _a.productPack) === null || _b === void 0 ? void 0 : _b.poisonSchedule,
                                expiryType: props.lastMedication.medication.expiryType,
                                expiresOn: getExpiresOn(true, performedDate(moment().endOf('day').format(ValidDateFormats.IsoFormat), ValidDateFormats.IsoFormat), expiresOnMoment, performedOnMoment, durationType)
                            }
                        ],
                        represcribedOn: moment().format(ValidDateFormats.NodeDateTimeTimezone),
                        service: {
                            id: emptyGuid,
                            authoringSystem: props.serviceAuthoringSystem,
                            authoringSystemForeignKey: props.serviceAuthoringSystemForeignKey
                        }
                    };
                    if (!(!props.lastMedication.productPack.productRemoved &&
                        props.controlledMedicationHandler.requiresAuthentication((_d = (_c = props.lastMedication.productPack) === null || _c === void 0 ? void 0 : _c.poisonSchedule) === null || _d === void 0 ? void 0 : _d.poisonScheduleStatus))) return [3 /*break*/, 1];
                    props.controlledMedicationHandler.showControlledMedicationDialog({
                        action: {
                            type: ControlledDialogActions.Represcribe,
                            payload: represcribeValues,
                            patient: props.patient
                        },
                        handleCancel: props.onClose
                    });
                    props.onClose();
                    return [3 /*break*/, 5];
                case 1:
                    setReprescribing(true);
                    _e.label = 2;
                case 2:
                    _e.trys.push([2, 4, , 5]);
                    if (props.lastMedication.productPack.productRemoved) {
                        shortedMedsDetails = {
                            type: props.lastMedication.medication.type,
                            productRemoved: props.lastMedication.productPack.productRemoved,
                            isOnLemiOrLmbc: props.lastMedication.productPack.isOnLemiOrLmbc,
                            brandName: props.lastMedication.productPack.brandName,
                            activeIngredientName: props.lastMedication.productPack.activeIngredientName,
                            alternateMedication: null
                        };
                        represcribeValues.medications[0].shortenedMedsDetails = shortedMedsDetails;
                    }
                    return [4 /*yield*/, props.saveMedicationsToReprescribe(represcribeValues)];
                case 3:
                    represcribedMedications = _e.sent();
                    represcribedMedications.medications.length && displayMessage('Medication saved as draft');
                    setReprescribing(false);
                    props.onClose();
                    represcribedMedications.medications.length && props.onReprescribe(represcribedMedications === null || represcribedMedications === void 0 ? void 0 : represcribedMedications.medications[0]);
                    return [3 /*break*/, 5];
                case 4:
                    e_1 = _e.sent();
                    setReprescribing(false);
                    props.onClose();
                    displayError('Unable to re-prescribe medication');
                    return [3 /*break*/, 5];
                case 5: return [2 /*return*/];
            }
        });
    }); };
    return props.lastMedication.productPack === null ? (React.createElement(StyledDialog, { open: true, size: 'xxs', modal: true, testId: 'represcribe-medication-loading-dialog', contentComponent: React.createElement(LayoutCentral, null,
            React.createElement("div", { className: styles.body },
                React.createElement("div", { className: styles.info }, "Loading medication..."),
                React.createElement(ColorLinearProgress, { className: styles.progress }))) })) : (React.createElement(StyledDialog, { open: true, size: 'xs', modal: true, testId: 'represcribe-medication', title: 'Re-prescribe medication', titleBarRight: React.createElement(Button, { iconOnly: true, onClick: function () { return props.onClose(); }, noShadowOnHover: true, subtleShadeOnHover: true, testId: 'represcribe-medication-close', tooltip: 'Close' },
            React.createElement(CloseIcon, { size: '20', color: white50, noPadding: true })), actions: props.lastMedication.productPack.productRemoved === false
            ? [
                React.createElement(StyledDialogButton, { variant: ButtonVariant.light, key: 'cancel', disabled: represcribing, testId: 'represcribe-medication-cancel', onClick: function () { return props.onClose(); } }, "Cancel"),
                React.createElement(StyledDialogButton, { variant: ButtonVariant.primary, key: 'confirm', disabled: represcribing, testId: 'represcribe-medication-confirm', onClick: function () { return represcribeMedication(); } }, "Continue")
            ]
            : [
                React.createElement(StyledDialogButton, { variant: ButtonVariant.light, key: 'cancel', disabled: represcribing, testId: 'represcribe-medication-cancel', onClick: function () { return props.onClose(); } }, "Cancel"),
                props.lastMedication.medication.status === MedicationStatus.Stopped ? (React.createElement(StyledDialogButton, { variant: ButtonVariant.primary, key: 'confirm', disabled: represcribing, testId: 'represcribe-medication-confirm', onClick: function () { return represcribeMedication(); } }, "Add new")) : (React.createElement(StyledDialogButton, { variant: ButtonVariant.primary, key: 'confirm', disabled: represcribing, testId: 'represcribe-medication-confirm', onClick: function () { return represcribeMedication(); } }, "Stop & Add new"))
            ], contentComponent: props.lastMedication.productPack.productRemoved === false ? (React.createElement("div", { className: styles.dialogContent },
            React.createElement("div", { className: styles.heading }, "Are you sure you want to re-prescribe the following medication?"),
            React.createElement("div", { className: styles.information }, "The existing medication will be stopped and a new draft medication created."),
            React.createElement("ul", null,
                React.createElement("li", null, props.medicationName)))) : (React.createElement("div", { className: styles.dialogContent },
            React.createElement("div", { className: styles.heading }, "The selected medication is no longer available for prescribing."),
            React.createElement("ul", null,
                React.createElement("li", null, props.medicationName)),
            React.createElement("div", { className: styles.information }, props.lastMedication.medication.status === MedicationStatus.Stopped ? (React.createElement("span", null,
                "Click ",
                React.createElement("strong", null, "Add new"),
                " to select an alternative from the medication browser.")) : (React.createElement("span", null,
                "Click ",
                React.createElement("strong", null, "Stop & Add new"),
                " to stop the medication and select an alternative from the medication browser."))))) }));
};
